import { createSelector } from '@reduxjs/toolkit';
import { functionsNotDeleted } from './functions-not-deleted';
import { currentEmployeeUuid } from '../employees/current-employee-uuid';

export const currentEmployeeFunctions = createSelector(
  functionsNotDeleted,
  currentEmployeeUuid,
  (functions, employeeId) => {
    const list: string[] = [];
    for (const item of functions) {
      if (employeeId !== undefined && item.employees !== undefined && item.employees.includes(employeeId)) {
        list.push(item.uuid);
      }
    }
    return list;
  },
);
